import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EstimatedMarketingReachSetup from "../components/estimated-marketing-reach-setup";
import { mcSquareApiSlice, useGetEstimatedMarketingReachCheckQuery } from "../features/mc-square-api/mc-square-api-slice";

const MIN_LOADING_TIME_MS = 3000;

const EstimatedMarketingReachSetupContainer = () => {
  const { data, isLoading: queryIsLoading, currentData, isError } = useGetEstimatedMarketingReachCheckQuery();
  const [isLoading, setIsLoading] = useState(true);
  const queryStart = React.useRef(Date.now());

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNext = () => {
    dispatch(mcSquareApiSlice.util.invalidateTags(['session']));

    navigate('/audience');
  }

  useEffect(() => {
    if (!currentData) {
      if (!queryIsLoading) {
        const elapsed = Date.now() - queryStart.current;
        const remainingDelay = Math.max(MIN_LOADING_TIME_MS - elapsed, 0);

        const timeout = setTimeout(() => setIsLoading(false), remainingDelay);
        return () => clearTimeout(timeout);
      }
    } else {
      setIsLoading(false);
    }

    return undefined;
  }, [queryIsLoading]);

  return (
    <EstimatedMarketingReachSetup
      data={data}
      onNext={handleNext}
      isError={isError}
      isLoading={!currentData && isLoading}
    />
  );
};

EstimatedMarketingReachSetupContainer.propTypes = {};

export default EstimatedMarketingReachSetupContainer;
